'use strict';

var buildTextKey = function (text) { return text.toLowerCase().replace(/\s/g, '-').slice(0, 5); };

exports.buildTextKey = buildTextKey;
